import { render, staticRenderFns } from "./PaymentMethodNew.vue?vue&type=template&id=41fbbd24&scoped=true"
import script from "./PaymentMethodNew.vue?vue&type=script&lang=js"
export * from "./PaymentMethodNew.vue?vue&type=script&lang=js"
import style0 from "./PaymentMethodNew.vue?vue&type=style&index=0&id=41fbbd24&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41fbbd24",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\business\\yoyotravel\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41fbbd24')) {
      api.createRecord('41fbbd24', component.options)
    } else {
      api.reload('41fbbd24', component.options)
    }
    module.hot.accept("./PaymentMethodNew.vue?vue&type=template&id=41fbbd24&scoped=true", function () {
      api.rerender('41fbbd24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/products/PaymentMethodNew.vue"
export default component.exports